module.exports = __webpack_public_path__ + "img/rule.f9522705.png";